import $ from "jquery";
import "./summaryButton.scss";
import { state, SIZE_DATA, COLORS_DATA, ACCESSORIES_DATA, INSTALLATION_PRICE } from "../../../core/settings";
import { pergola } from "../../../core/3d-configurator";
import { resolveAndUpdatePrice } from "../../../core/addToCartFunctions/priceResolver";

// When async XML prices arrive, update the displayed total directly
window.addEventListener('priceResolved', ({ detail: { total } }) => {
  $('.addToCart__total-price').text(formatPrice(total));
});

function getPlacementCounts() {
  const counts = {};
  const placed = pergola?.getPlacedAccessories?.() ?? [];
  placed.forEach(({ accessoryKey, permanent }) => {
    if (permanent) return;
    counts[accessoryKey] = (counts[accessoryKey] || 0) + 1;
  });
  return counts;
}

function computeTotal() {
  let total = 0;

  const sizes = SIZE_DATA[state.shapeType];
  const s = sizes?.[state.sizeIndex] ?? sizes?.[0];
  if (s) total += s.price;

  const colorEntry = COLORS_DATA.find(c => c.hex === state.colorBody);
  if (colorEntry?.surcharge) total += colorEntry.surcharge;

  const allItems = ACCESSORIES_DATA.flatMap(section => section.items);
  const counts = getPlacementCounts();
  for (const key of state.subAccessoriesUrl) {
    const item = allItems.find(i => i.key === key);
    if (!item) continue;
    let unitPrice = Array.isArray(item.price) ? item.price[0] : item.price;
    if (Array.isArray(item.price) && state.windowModes?.[key] === 'auto-window') {
      unitPrice = item.price[1];
    }
    total += unitPrice * (counts[key] || 0);
  }

  if (state.countryType === 0 && state.installation) total += INSTALLATION_PRICE;

  return total;
}

function formatPrice(n) {
  return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
}

function collectCartData() {
  const countryLabels = { 0: 'Belgium', 1: 'France' };
  const shapeLabels   = { 0: 'Straight walls', 1: 'Sloping walls', 2: 'Extra-high walls' };

  const sizes = SIZE_DATA[state.shapeType];
  const s = sizes?.[state.sizeIndex] ?? sizes?.[0];

  const colorEntry = COLORS_DATA.find(c => c.hex === state.colorBody) ?? COLORS_DATA[0];

  const allItems = ACCESSORIES_DATA.flatMap(section => section.items);
  const selectedAccessories = [...state.subAccessoriesUrl].map(key => {
    const item = allItems.find(i => i.key === key);
    return item ? { key: item.key, name: item.name, price: item.price } : null;
  }).filter(Boolean);

  return {
    country:       countryLabels[state.countryType],
    shape:         shapeLabels[state.shapeType],
    size: s ? {
      code:   s.code,
      width:  s.width,
      length: s.length,
      price:  s.price,
    } : null,
    color: {
      name:      colorEntry.name,
      hex:       state.colorBody,
      ral:       colorEntry.ral ?? null,
      surcharge: colorEntry.surcharge ?? 0,
    },
    accessories: selectedAccessories,
    installation: state.countryType === 0 ? {
      selected: state.installation,
      price:    state.installation ? INSTALLATION_PRICE : 0,
    } : null,
    totalPrice: computeTotal(),
  };
}

export function addToCartButtonComponent(container) {
  const $wrap = $(`
    <div class="addToCart__wrap">
      <div class="addToCart__total">
        <span class="addToCart__total-price">${formatPrice(computeTotal())}</span>
      </div>
      <button type="button" class="addToCart__button">
        <span class="cart-icon"></span>
        <span class="cart-text">Add to cart</span>
      </button>
    </div>
  `);

  $wrap.find('.addToCart__button').on('click', async () => {
    const cartData = collectCartData();
    console.log('TEST: Cart data:', cartData);
  });

  // refresh total price each time the wrap becomes visible
  $wrap.on('refreshTotal', function () {
    $(this).find('.addToCart__total-price').text(formatPrice(computeTotal()));
  });

  $(container).append($wrap);
}

export function refreshCartTotal() {
  // Immediate sync display using hardcoded prices as a placeholder
  $('.addToCart__wrap').trigger('refreshTotal');
  // Async: fetch live XML prices and update when ready
  resolveAndUpdatePrice();
} 
